import React, { useContext } from 'react';
import Calendars from  '@/components/elements/plannerSettings/Calendars';
import EditCalendar from  '@/components/elements/plannerSettings/EditCalendar';
import AddCalendar from  '@/components/elements/plannerSettings/AddCalendar';
import { HashRouter as Router, Routes, Route } from 'react-router'
import ModalWrapper from  '@/components/modals/ModalWrapper';
import { BuildPath } from  '@/helpers/Paths';
import { IloadingType, PlannerSettingsContext } from '@/context/PlannerSettingsContext';
import '../../css/plannerSettings.scss'

const PlannerSettings = () => {

    const {loading, loadingType} = useContext(PlannerSettingsContext);

    return (
        <>
            <Router>
                <Routes>
                    <Route path="/" element={<Calendars />} />
                    <Route path="/addcalendar" element={<AddCalendar />} />
                    <Route path="/editcalendar/:id" element={<EditCalendar />} />    
                </Routes>
            </Router>

            <ModalWrapper isOpen={loading && loadingType !== null} onRequestClose={() => {}} hideCloseButton={true} className="loading">
                <div className='loading-settings'>
                    {loadingType === IloadingType.loading ? "Fetching" : "Saving"} planner settings...
                    <img className="spinner" src={`${BuildPath()}/images/spinner.gif`} alt="loading..." />
                </div>
            </ModalWrapper>
        </>
    );
};

export default PlannerSettings

